import cloneDeep from 'lodash/cloneDeep';
import { RETAILER_TYPE } from 'app/validators/roles';
import { deleteLinkedRetailers, updateLinkedRetailers } from 'user/actions/linked-retailers.actions';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import template from './account-retailers.html';

const DIRTY_FORM = 'accountRetailers';

const mapStateToThis = ({ session, linkedRetailers }) => {
  const { isAdmin } = session;
  const { isSaving } = linkedRetailers;

  return {
    isAdmin,
    isSaving,
  };
};

const mapDispatchToThis = {
  setDirtyForm,
  updateLinkedRetailers,
  deleteLinkedRetailers,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'gettextCatalog', 'Notifications', 'Responsive')
class AccountRetailersController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.DIRTY_FORM = DIRTY_FORM;
    this.selectedRetailers = cloneDeep(this.model.user.editAccount.retailers) || [];
    this.selectedRetailersCount = this.selectedRetailers.length;
    this.validateRetailers();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  validateRetailers() {
    this.valid = this.selectedRetailers.find(
      (retailer) => [
        RETAILER_TYPE.INDEPENDENT,
        RETAILER_TYPE.CHAIN_HEAD,
      ].includes(retailer.retailerType),
    );
  }

  onRetailerSelect(selectedRetailers) {
    this.selectedRetailers = [...selectedRetailers];
    this.selectedRetailersCount = this.selectedRetailers.length;
    this.validateRetailers();
    this.setDirtyForm(this.DIRTY_FORM, true);
  }

  cancel() {
    this.setDirtyForm(this.DIRTY_FORM, false);
    this.$state.go('user-manageUsers');
  }

  async save() {
    if (!this.valid) return;
    const promises = [];
    const userEmail = this.model.user.editAccount.username;
    const userId = this.model.user.editAccount.id;
    const retailerIdsToUpdate = this.getRetailerIdsToUpdate();
    const retailerIdsToDelete = this.getRetailerIdsToDelete();

    if (retailerIdsToUpdate.length > 0) {
      const data = {
        userEmail,
        retailerIds: retailerIdsToUpdate,
      };
      promises.push(this.updateLinkedRetailers(data));
    }
    if (retailerIdsToDelete.length > 0) {
      const data = {
        userEmail,
        retailerIds: retailerIdsToDelete,
      };
      promises.push(this.deleteLinkedRetailers(data));
    }

    Promise.all(promises)
      .then(() => this.api.loadUser(this.model, userId))
      .then(() => {
        this.Notifications.alertSuccess(this.gettextCatalog.getString('Linked retailers updated successfully'));
        this.setDirtyForm(this.DIRTY_FORM, false);
      });
  }

  getRetailerIdsToUpdate() {
    return this.selectedRetailers.map((retailer) => retailer.retailerId);
  }

  getRetailerIdsToDelete() {
    const retailersToDelete = this.model.user.editAccount.retailers.filter(
      (retailer) => !this.selectedRetailers
        .find((selectedRetailer) => selectedRetailer.retailerId === retailer.retailerId),
    ) || [];

    return retailersToDelete.map((retailer) => retailer.retailerId);
  }
}

export default class AccountRetailersComponent {
  constructor() {
    this.template = template;
    this.controller = AccountRetailersController;
    this.bindings = {
      model: '<',
      api: '<',
      canEditAccountDetails: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/components/edit-account/components/account-retailers/account-retailers-component.js